// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

// إعدادات مشروعك من الفايربيز
const firebaseConfig = {
  apiKey: "AIzaSyBe3EizpilETDIgv4YHQSOYXYMGIKbNxj0",
  authDomain: "getaak-b9b45.firebaseapp.com",
  projectId: "getaak-b9b45",
  storageBucket: "getaak-b9b45.firebasestorage.app",
  messagingSenderId: "631382313660",
  appId: "1:631382313660:web:9c9512476f1d86c34d9eb9"
};

// يربط مشروعك على الفايربيز مع تطبيق الريأكت
const app = initializeApp(firebaseConfig);

// يجهز 
// FCM (firebase cloud messaging)
// لإرسال واستقبال الشعارات
export const messaging = getMessaging(app);